// CustomerPassword.js
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PasswordChecker from './../../helpers/PasswordChecker/PasswordChecker'
import './admin-customer-password.css';

function AdminCustomerPassword({ defaultValue, onChange }) {
  const { t } = useTranslation();
  const [password, setPassword] = useState(defaultValue ? defaultValue : '');

  const setPasswordIsValid = (isValid) => {
    onChange({ password: password, passwordIsValid: isValid });

  }


  function generatePassword() {
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const digits = "0123456789";
    const special = "@$!%&#";
    const all = lower + upper + digits + special;

    // Obligatoires : 1 de chaque
    let password = [
      lower[Math.floor(Math.random() * lower.length)],
      upper[Math.floor(Math.random() * upper.length)],
      digits[Math.floor(Math.random() * digits.length)],
      special[Math.floor(Math.random() * special.length)],
    ];

    // Compléter jusqu'à 9
    while (password.length < 9) {
      password.push(all[Math.floor(Math.random() * all.length)]);
    }

    // Shuffle pour éviter l'ordre fixe

    const pwd = password
      .map(value => ({ value, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ value }) => value)
      .join('')
    setPassword(pwd)
    onChange({ password: pwd });
  }


  return (
    <div id="CustomerPassword">
      <div className='row'>
        <div className='col-sm-8  pe-3'>
          <div className='form-group'>
            <label className='form-group-label'>Nouveau mot de passe : </label>
            <div className='input-group input-group-sm'>
              <input type='text' className='form-control form-control-sm' name="userName" onChange={e => setPassword(e.target.value)} value={password} required />
              <button className='btn btn-green' onClick={generatePassword} >Créer un mot de passe</button>
            </div>

          </div>
        </div>
      </div>
      {true && <PasswordChecker password={password} isValid={v => setPasswordIsValid(v)} />}

    </div >
  );
}
export default AdminCustomerPassword;
